module.exports = __webpack_public_path__ + "static/media/40.095ad158.png";